import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import Strong from '@tds/core-strong';

import { Thead, Tr, Th, Td } from './css';
import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';
import getFormattedPricing from '../../utils';
import RatePlanTableRow from './rateplanTableRow';

const RatePlanTable = ({
  orderType,
  productSelected,
  accountType,
  viewType,
  ratePlans,
  setRatePlans,
  rateplanList,
  total,
  setTotal,
  setRatePlanError
}) => {
  const {
    contentfulValues: { valueCorporate, valueUnitPrice, valueTotal, valueRaven }
  } = useLocalizedStringsContext();

  const getHeader = list => (
    <Thead>
      <Tr>
        {list.map(item => {
          if (
            !(
              [valueUnitPrice, valueTotal].includes(
                _.get(item, 'fields.title', '')
              ) && accountType === valueCorporate
            )
          )
            return <Th>{_.get(item, 'fields.title', '')}</Th>;
          return null;
        })}
      </Tr>
    </Thead>
  );

  useEffect(() => {
    const ratePlanGrandTotal = Object.keys(ratePlans).reduce((acc, current) => {
      const ratePlanTotal = Object.keys(ratePlans[current]).reduce(
        (rateplanAcc, item) => {
          const { quantity, unitPrice } = ratePlans[current][item];
          if (quantity && unitPrice) return rateplanAcc + unitPrice * quantity;
          return rateplanAcc;
        },
        0
      );
      return acc + ratePlanTotal;
    }, 0);

    setTotal(previousValue => ({
      ...previousValue,
      ratePlan: ratePlanGrandTotal
    }));
  }, [ratePlans]);

  useEffect(() => {
    if (productSelected === valueRaven) {
      setTotal(previousValue => ({
        ...previousValue,
        ratePlan: 0
      }));
    }
  }, [accountType]);

  return (
    <table>
      {rateplanList.map(rateplan =>
        _.get(rateplan, 'fields.isHeader', false) ? (
          <>{getHeader(_.get(rateplan, 'fields.headerList', []))}</>
        ) : (
          <RatePlanTableRow
            key={_.get(rateplan, 'sys.id', '')}
            orderType={orderType}
            productSelected={productSelected}
            accountType={accountType}
            rowData={rateplan}
            viewType={viewType}
            ratePlans={ratePlans}
            setRatePlans={setRatePlans}
            setRatePlanError={setRatePlanError}
          />
        )
      )}
      {accountType !== valueCorporate && (
        <Tr style={{ background: '#f4f4f4' }}>
          <Td colSpan={5}>
            <Strong>Total</Strong>
          </Td>
          <Td>
            <Strong>{getFormattedPricing(total)}</Strong>
          </Td>
        </Tr>
      )}
    </table>
  );
};

RatePlanTable.propTypes = {
  orderType: PropTypes.string.isRequired,
  productSelected: PropTypes.string.isRequired,
  accountType: PropTypes.string.isRequired,
  viewType: PropTypes.string.isRequired,
  ratePlans: PropTypes.arrayOf(PropTypes.object).isRequired,
  setRatePlans: PropTypes.func.isRequired,
  rateplanList: PropTypes.arrayOf(PropTypes.object).isRequired,
  total: PropTypes.number.isRequired,
  setTotal: PropTypes.func.isRequired,
  setRatePlanError: PropTypes.func.isRequired
};

export default RatePlanTable;
